import "../css/users.css";

import React from "react";
import Breadcrumb from "../components/breadcrumb";
import ModalForm from "../components/modalForm";
import { Helmet, HelmetProvider } from 'react-helmet-async';

const FacebookToken = () => {  

    let breadcrumbItens = [
        {
            text: "Home",
            route: "/"
        },
        {
            text: "Facebook",
            route: "/facebook"
        },
        {
            text: "Facebook Token",
            route: "#"
        }
    ];

    let inputs = [
            {              
                type: "text",
                name: "name",
                label: "Nome",
                isRequired: true
            },
            {              
                type: "date",
                name: "expires_at",
                label: "Expira em",
                isRequired: true
            },

            {
                type: "text",
                name: "token",
                label: "Token",
                isRequired: false
            }
    ];

    return (
        <div className="container">
            <ModalForm input={inputs} action="save-facebook-token" elemId="facebookTokenModal" isEdit={false} title="Facebook Token" />
            <ModalForm input={inputs} action="update-facebook-token" elemId="editFacebookTokenModal" isEdit={true} title="Facebook Token" />

            <div className="defaultContainer">
               
                <div className="row">
                    <div className="col-12">
                        <h1 className="h1">Facebook Token
                            <button type="button" className="btn btn-sm btn-add" data-bs-toggle="modal" data-bs-target="#facebookTokenModal">
                                <span className="material-symbols-outlined transition">add_box</span>
                            </button>
                        </h1>
                        <Breadcrumb links={breadcrumbItens} />
                    </div>
                </div>
                <br />
                
                <div className="row">
                    <div className="col-12">
                        <table id="dtFacebookToken" className="dataTables cell-border table table-bordered table-striped" style={{width:"100%"}}>
                            <thead>
                                <tr className="thead-dark">
                                    <th>Nome</th>
                                    <th>Token</th>
                                    <th>Expira em</th>
                                    <th>Criado em</th>
                                    <th>Atualizado em</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody></tbody>
                            <tfoot></tfoot>
                        </table>    
                    </div>
                </div> 

            </div>
            <HelmetProvider>
                <Helmet>
                    <script src="./js/checkPermissions.js" type="text/javascript"></script>
                    <script src="./js/datatables/facebook-token.js" type="text/javascript"></script>
                </Helmet>
            </HelmetProvider>  
        </div>
    );
}

export default FacebookToken;